<template>
  <v-card class="my-0">
    <v-toolbar dense flat  v-if="label">
      <v-icon color="warning" v-if="experience.length === 0">mdi-alert-circle</v-icon>
      {{ label }}
      <v-spacer/>
      <v-btn icon @click="create_dialog = !create_dialog"><v-icon>mdi-plus</v-icon></v-btn>
    </v-toolbar>
    <v-divider/>

    <template v-if="profile_type === 'aspiringSolicitor'">
      <v-subheader>Maximum of four placements, for more information, please see
        <a class="success--text px-1" target="_blank" href="https://www.lawsociety.org.uk/law-careers/becoming-a-solicitor/sqe-overview/#sqe8">
          Solicitors Qualifying Exam
        </a>
      </v-subheader>
      <v-divider/>
    </template>

    <v-card-text v-if="experience.length > 0">
      <v-list-item v-for="(item, idx) in experience" :key="idx">
        <v-list-item-content>{{ item.name }}</v-list-item-content>
        <v-list-item-action>
          {{ item.duration}}
        </v-list-item-action>

        <v-list-item-action>
          <v-btn color="red" small icon @click="rmExperience(idx)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-card-text>

    <v-dialog v-model="create_dialog" max-width="500px">
      <v-card>
        <v-toolbar dark color="success">
          <v-btn icon dark @click="create_dialog = !create_dialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Add</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="addExperience">Add</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-combobox v-model="major_position"
                    :items="items"
                    item-text="name"
                    item-value="id"
                    label="Position"
                    :error-messages="form_errors['position']"
          />

          <v-select v-model="duration"
                    :items="duration_options"
                    label="Duration"
                    :error-messages="form_errors['duration']"
          />
        </v-card-text>

      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: Array,
        default: Array
      },
      items: {
        type: Array,
        default: Array
      },
      label: {
        type: String,
        default: ''
      },
      errorMessages: {
        type: Array,
        default: Array
      },
    },
    data() {
      return {
        create_dialog: false,
        experience: [],
        major_position: null,
        duration: '1',
        duration_options: [
          { text: '0-1 year', value: '1' },
          { text: '2-5 years', value: '2-5' },
          { text: '5+', value: '5+' },
          { text: '10+', value: '10+' },
        ],
        form_errors: []
      }
    },
    computed: {
      ...mapGetters({
        authUser: 'getAuthUser',
        profile_type: 'getAuthUserProfileType',
      }),
    },
    watch: {
      value: function (val) {
        this.experience = new Array(...val)
      }
    },
    methods: {
      addExperience() {
        this.form_errors = []
        if(!this.major_position){
          this.form_errors['position'] = 'Position is require'
          return
        }
        if(!this.duration){
          this.form_errors['duration'] = 'Duration is require'
          return
        }

        this.experience.push({
          ...this.major_position,
          duration: this.duration,
        })

        this.create_dialog = false
        this.updateExperience()
      },
      rmExperience(idx) {
        this.experience.splice(idx, 1)
        this.updateExperience()
      },

      updateExperience(){
        this.api_errors = []
        this.axios.post('api/user/update-experience', {experience: this.experience})
          .then(() => {
            this.$emit('change')
          })
          .catch(errors => {this.api_errors = errors.response.data.data})
      },
    }
  }
</script>
